module.exports = __webpack_public_path__ + "img/aqt-logo2.0971775e.png";